import { FaqQuestionType } from '@/components/elements/FaqQuestion';
import FaqLayout, { FaqLayoutProps } from '@/components/layouts/FaqLayout';
import DefaultTemplate from '@/components/templates/Default';
import fire from '@/utils/firebase';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { FAQPageJsonLd } from 'next-seo';
import React, { useMemo } from 'react';

export default function FAQ({ faqData }: FaqLayoutProps) {
  const questions = useMemo(() => {
    const res: FaqQuestionType[] = [];
    faqData.forEach((item) => {
      item.questions.forEach((el) => {
        res.push(el);
      });
    });
    return res;
  }, [faqData]);
  return (
    <DefaultTemplate>
      <FAQPageJsonLd
        mainEntity={questions.map((item) => ({
          questionName: item.title,
          acceptedAnswerText: item.answer,
        }))}
      />
      <FaqLayout faqData={faqData} />
    </DefaultTemplate>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const faq = await fire.firestore().collection(`faq`).get();
  const SECONDS_IN_A_DAY = 84_400;
  return {
    props: {
      faqData: faq.docs.map((item) => ({ id: item.id, ...item.data() })),
      ...(await serverSideTranslations(locale as string, [`common`, `faq`])),
    },
    revalidate: SECONDS_IN_A_DAY,
  };
};
